import { isValid } from 'date-fns';
import { DataPoint } from '../generated/graphql';

type DataPointGroupGenericBase = { latestDataPoint?: DataPoint | null; updatedAt: string | undefined };

export function latestDataPointGroupUpdateDateTime<E extends DataPointGroupGenericBase>(
  dataPointGroup: E | undefined | null
) {
  return dataPointGroup?.latestDataPoint?.dateTime ?? dataPointGroup?.updatedAt;
}

export function latestDataPointGroupUpdateDate<E extends DataPointGroupGenericBase>(
  dataPointGroup: E | undefined | null
) {
  const dateString = latestDataPointGroupUpdateDateTime(dataPointGroup);

  if (isValid(new Date(dateString))) return new Date(dateString);
}
